export default __webpack_public_path__ + "static/media/red_slider.1ae38dbf.svg";